import forEach from 'lodash/forEach';

export const UPDATE_PROPS = (state, props) => {
	forEach(props, (value, key) => {
		state[key] = value;
	});
};
